import React from 'react';
import styled from 'styled-components';

export function FormLabel(props) {
	return <Label {...props}>{props.children}</Label>;
}

const Label = styled.label`
	margin: 3rem 0 1rem;
	font-size: 17px;
	font-weight: 600;
`;
